export default {
  // 通用
  'pages.common.operation': '操作',

  // FirmwarePackage 固件包元数据
  'pages.firmwarePackage.pageTitle': '固件包元数据',
  'pages.firmwarePackage.headerTitle': '上传 OTA 固件后自动写入/更新元数据；可在此设置产线默认包与状态。',
  'pages.firmwarePackage.editModalTitle': '编辑固件包',
  'pages.firmwarePackage.fileRelPath': '相对路径',
  'pages.firmwarePackage.fileSize': '大小',
  'pages.firmwarePackage.isProductionDefault': '产线默认',
  'pages.firmwarePackage.isProductionDefaultLabel': '产线默认包（同型号仅建议一条）',
  'pages.firmwarePackage.remark': '备注',
  'pages.firmwarePackage.saved': '已保存',

  // OTAVersionPanel OTA 版本管理
  'pages.otaVersion.cardTitle': 'OTA版本管理',
  'pages.otaVersion.waitingServerResponse': '等待服务器响应...',
  'pages.otaVersion.uploadFailedStatus': '上传失败 ({status}): {detail}',
  'pages.otaVersion.networkError': '网络错误',
  'pages.otaVersion.uploadTimeout': '上传超时',
  'pages.otaVersion.createSuccess': '设备版本创建成功',
  'pages.otaVersion.createFailed': '创建失败，请重试',
  'pages.otaVersion.versionCountLabel': '{count}个版本',
  'pages.otaVersion.uploadProgress': '上传进度：',
  'pages.otaVersion.deviceNamePlaceholder': '输入设备名称过滤',
  'pages.otaVersion.deviceTypePlaceholder': '输入设备型号过滤',
  'pages.otaVersion.addDeviceVersion': '添加设备版本',
  'pages.otaVersion.total': '共 {total} 条',
  'pages.otaVersion.deviceTypeRequired': '请输入设备型号',
  'pages.otaVersion.deviceTypeExample': '例如: esp32-s3',
  'pages.otaVersion.deviceName': '设备名称',
  'pages.otaVersion.noDeviceName': '未命名',
  'pages.otaVersion.deviceType': '设备型号',
  'pages.otaVersion.currentVersion': '固件版本',
  'pages.otaVersion.noVersion': '暂无版本',
  'pages.otaVersion.historyVersions': '历史版本',
  'pages.otaVersion.noHistoryVersions': '暂无历史版本',
  'pages.otaVersion.uploadFirmware': '上传固件',
  'pages.otaVersion.selectFile': '选择文件',
  'pages.otaVersion.delete': '删除',
  'pages.otaVersion.deleteConfirm': '确认删除',
  'pages.otaVersion.deleteContent': '确定要删除该历史版本吗？',
  'pages.otaVersion.deleteSuccess': '历史版本删除成功',
  'pages.otaVersion.deleteFailed': '历史版本删除失败',
  'pages.otaVersion.fetchFailed': '获取版本数据失败',
  'pages.otaVersion.uploadSuccess': '固件上传成功',
  'pages.otaVersion.uploadFailed': '固件上传失败',
  'pages.otaVersion.invalidFileName': '文件名格式不正确，必须为xx.yy.zz.bin格式',
  'pages.otaVersion.fileTooLarge': '文件大小不能超过500MB',
  'pages.otaVersion.versionNotNewer': '上传的版本必须比当前最新版本新',

  // OpsManage 运维管理
  'pages.admin.ops.waitingServerResponse': '等待服务器响应...',
  'pages.admin.ops.upload.successToast': '上传成功！',
  'pages.admin.ops.upload.failedStatus': '上传失败 ({status}): {detail}',
  'pages.admin.ops.upload.networkError': '网络错误，上传失败',
  'pages.admin.ops.upload.timeout': '上传超时，请重试',
  'pages.admin.ops.upload.canceled': '上传已取消',
  'pages.admin.ops.serverVersion': 'Server Version',
  'pages.admin.ops.rollbackVersion': 'Rollback Version',
  'pages.admin.ops.rollback.button': '回滚服务',
  'pages.admin.ops.rollback.confirmTitle': '谨慎操作：确认要回滚服务吗？',
  'pages.admin.ops.rollback.desc': '回滚服务将恢复到上一个版本，当前版本的数据可能会丢失。',
  'pages.admin.ops.rollback.warn': '此操作不可逆，请确保已备份重要数据。',
  'pages.admin.ops.rollback.ok': '确认回滚',
  'pages.admin.ops.rollback.cancel': '取消',
  'pages.admin.ops.rollback.success': '服务回滚指令已发送',
  'pages.admin.ops.rollback.error': '服务回滚失败',

  // Product 产品
  'pages.products.deviceType.direct': '直连设备',
  'pages.products.deviceType.gatewaySub': '网关子设备',
  'pages.products.deviceType.gateway': '网关设备',
  'pages.products.locationType.ip': 'IP定位',
  'pages.products.locationType.deviceReport': '设备上报',
  'pages.products.locationType.manual': '手动定位',
  'pages.products.netType.other': '其他',
  'pages.products.rule.nameRequired': '请输入产品名称',
  'pages.products.rule.codecTypeRequired': '请输入编解码器类型',
  'pages.products.rule.productKeyRequired': '请输入产品标识',
  'pages.products.rule.deviceTypeRequired': '请选择设备类型',
  'pages.products.rule.locationTypeRequired': '请选择定位方式',
  'pages.products.rule.netTypeRequired': '请选择网络类型',
  'pages.products.addButton': '添加产品',
  'pages.products.create.modal.categoryLabel': '产品分类',
  'pages.products.card.id': 'ID',
  'pages.products.card.confirmDelete': '确认删除吗？',
  'pages.products.model.deviceTypeLabel': '设备类型',
  'pages.products.model.locationTypeLabel': '定位方式',
  'pages.products.model.netTypeLabel': '网络类型',
  'pages.products.model.codecTypeLabel': '编解码方式',
  'pages.products.save.success': '保存成功',
  'pages.products.save.failed': '保存失败',
  'pages.products.delete.success': '删除成功',
  'pages.products.delete.failed': '删除失败',

  // ProductCategory 产品分类
  'pages.productCategory.rule.nameRequired': '请输入名称',
  'pages.productCategory.rule.statusRequired': '请选择状态',
  'pages.productCategory.column.ID': 'ID',
  'pages.productCategory.column.ProductCategory.placeholder': '请选择或搜索产品设备型号',

  // ModelProviders 模型供应商
  'pages.admin.providers.typeCount': '{n} 个',

  // RecorderManage 录音管理
  'pages.admin.recorder.recordCount': '({n} 条)',

  // Settings 系统设置
  'pages.admin.settings.llmOpenSource.label': 'LLM（开源设备默认）',
  'pages.admin.settings.llmCommercial.label': 'LLM（商业授权设备默认）',
  'pages.admin.settings.sameAsAbovePlaceholder': '与上方列表一致',
  'pages.admin.settings.llmOpenSource.optionCommercialSuffix': '（需商业授权，不可作开源默认）',
  'pages.admin.settings.error.validation': '请修正表单校验错误后再保存',
  'pages.admin.settings.error.openSourceLlmCommercial': '开源设备默认不能选择需商业授权的 LLM',

  // ContractDevicePanel 协约设备
  'pages.contractDevice.macPattern': '请输入正确的MAC地址',

  // SystemConfig 页头 / Tab / 充值 / YAML（硬编码补齐）
  'pages.systemConfig.pageTitle': '系统配置管理',
  'pages.systemConfig.pageSubtitle': '管理系统的各项配置参数',
  'pages.systemConfig.pageAlertTitle': '配置管理说明',
  'pages.systemConfig.pageAlertDesc':
    '在这里您可以管理系统的各项配置，包括应用程序设置、服务器配置、认证设置等。修改配置后请及时保存。',
  'pages.systemConfig.tab.application': '应用配置',
  'pages.systemConfig.tab.transport': '传输配置',
  'pages.systemConfig.tab.web': 'Web配置',
  'pages.systemConfig.tab.auth': '认证配置',
  'pages.systemConfig.tab.roles': '角色配置',
  'pages.systemConfig.tab.localMcp': '本地MCP功能',
  'pages.systemConfig.tab.externalMcp': '外部MCP配置',
  'pages.systemConfig.tab.exitCommands': '退出指令',
  'pages.systemConfig.tab.log': '日志配置',
  'pages.systemConfig.tab.data': '数据配置',
  'pages.systemConfig.tab.quickReply': '快捷回复',
  'pages.systemConfig.tab.recharge': '充值/支付',
  'pages.systemConfig.tab.yaml': '完整YAML（只读）',
  'pages.systemConfig.quickReply.addWord': '添加回复词',
  'pages.systemConfig.yaml.cardTitle': '完整 YAML（server_configs，只读）',
  'pages.systemConfig.yaml.loadBtn': '从服务器加载',
  'pages.systemConfig.yaml.placeholder': '点击「从服务器加载」查看当前配置',
  'pages.systemConfig.recharge.cardTitle': '充值与微信支付',
  'pages.systemConfig.recharge.enabled': '启用充值模块',
  'pages.systemConfig.recharge.wechatPayDivider': '微信支付 wechat_pay',
  'pages.systemConfig.recharge.wechatEnabled': '启用微信支付',
  'pages.systemConfig.recharge.mchId': '商户号 mch_id',
  'pages.systemConfig.recharge.apiV3Key': 'APIv3 密钥（留空或 *** 不改）',
  'pages.systemConfig.recharge.certSerialNo': '商户证书序列号',
  'pages.systemConfig.recharge.privateKeyPath': '商户私钥 PEM 路径',
  'pages.systemConfig.recharge.notifyUrl': '支付结果 notify_url',
  'pages.systemConfig.recharge.refundNotifyUrl': '退款 notify_url（可选）',
  'pages.systemConfig.recharge.feeRate': '费率 fee_rate',
  'pages.systemConfig.recharge.feeBearer': '手续费承担 platform|user',
  'pages.systemConfig.recharge.wechatPublicKeyId': '微信支付公钥 ID',
  'pages.systemConfig.recharge.wechatPublicKeyPath': '微信支付公钥 PEM 路径',
  'pages.systemConfig.recharge.disableRefundOnSimFail': '物联充值失败时不自动微信退款',
  'pages.systemConfig.recharge.simPlatformsDivider': '物联平台 sim_platforms（JSON）',
  'pages.systemConfig.recharge.simPlatformsJson': '一级代理配置对象 JSON',
  'pages.systemConfig.recharge.simPlatformsJsonInvalid': '需为合法 JSON 对象',
  'pages.systemConfig.websocketPlaceholder': 'ws://你的ip:8000',

  // 全局错误提示
  'helpers.systemName.fallback': '项目模板',
  'helpers.error.loginFailed': '用户名或密码错误',
  'helpers.error.unauthorized': '错误：未登录或登录已过期，请重新登录！',
  'helpers.error.tooManyRequests': '错误：请求次数过多，请稍后再试！',
  'helpers.error.serverError': '错误：服务器内部错误，请联系管理员！',
  'helpers.error.prefix': '错误：',
  'helpers.error.demoOnly': '本站仅作演示之用，无服务端！',
  'helpers.error.requestFailed': '请求失败！',

  // services 层用户可见错误
  'pages.admin.providers.error.updateParams': '更新供应商时，type 和 name 参数都不能为空',
  'pages.admin.providers.error.deleteParams': '删除供应商时，type 和 name 参数都不能为空',
  'pages.admin.providers.error.testParams': '测试供应商时，type 和 name 参数都不能为空',
  'pages.admin.providers.error.toggleParams': '切换供应商状态时，type 和 name 参数都不能为空',
  'pages.admin.providers.error.invalidType': '无效的供应商类型: {type}，有效类型为: {validTypes}',
  'pages.knowledgeBase.error.noTaskId': '上传已受理但未返回任务 ID，请刷新列表后重试',
  'pages.knowledgeBase.error.indexFailed': '文档索引失败',
  'pages.knowledgeBase.error.processTimeout': '文档处理超时，请稍后在文档列表中查看状态',
};
